{
  "version": 1,
  "asset_id": "08c1655b-590c-439f-a455-20e50bfbb700",
  "project_id": "93ebf89f-7c73-440e-8d33-7be2cf392b2d",
  "url": "/__l5e/assets-v1/08c1655b-590c-439f-a455-20e50bfbb700/hero-king-salmon.mp4",
  "original_filename": "hero-king-salmon.mp4",
  "size": 15218765,
  "created_at": "2026-06-30T21:52:16Z"
}